if (typeof BSS_B2B) {
    if(window.location.pathname.includes("/products/")) {
        setTimeout(() =>{
        const targetForm = document.querySelector('[id^="product-form-installment-template"] input[name="id"]');
        if (targetForm) {
            const mutationObserver = new MutationObserver((recordList, observe) => {
            setTimeout(() =>{
                const productForm = document.querySelector("[bss-b2b-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
            }, 1000)
            
            });
            mutationObserver.observe(targetForm, { attributes: true });
        }
        }, 1000)
    }

}